import { render, staticRenderFns } from "./HotelAmenities.vue?vue&type=template&id=4b9bbf20&scoped=true"
import script from "./HotelAmenities.vue?vue&type=script&lang=js"
export * from "./HotelAmenities.vue?vue&type=script&lang=js"
import style0 from "./HotelAmenities.vue?vue&type=style&index=0&id=4b9bbf20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bbf20",
  null
  
)

export default component.exports